/*
Mobil-Menue: Der Hamburger in der Topbar oeffnet das vollflaechige
Overlay (#mobil-menue), das X darin oder Escape schliesst es wieder.

Auf- und Zufahren laeuft ueber die Klasse .ist-offen (Transitionen in
_mobil-menue.scss); waehrend das Overlay offen ist, sperrt die Klasse
mobil-menue-offen am <body> das Scrollen der Seite dahinter.
*/

jQuery(document).ready(function () {

	var $toggle = jQuery('.mobil-menue-toggle');
	var $menue = jQuery('#mobil-menue');

	if (!$toggle.length || !$menue.length) {
		return;
	}

	var schliessTimer = null;

	function auf() {
		window.clearTimeout(schliessTimer);
		$menue.prop('hidden', false);

		// Erzwungener Reflow, damit die Einblend-Transition greift.
		void $menue[0].offsetHeight;

		$menue.addClass('ist-offen');
		$toggle.addClass('ist-offen').attr('aria-expanded', 'true');
		jQuery('body').addClass('mobil-menue-offen');
		$menue.find('.mobil-menue-schliessen').trigger('focus');
	}

	function zu(fokusZurueck) {
		$menue.removeClass('ist-offen');
		$toggle.removeClass('ist-offen').attr('aria-expanded', 'false');
		jQuery('body').removeClass('mobil-menue-offen');

		schliessTimer = window.setTimeout(function () {
			$menue.prop('hidden', true);
		}, 300);

		if (fokusZurueck) {
			$toggle.trigger('focus');
		}
	}

	$toggle.on('click', function () {
		if ($menue.hasClass('ist-offen')) {
			zu(false);
		} else {
			auf();
		}
	});

	$menue.on('click', '.mobil-menue-schliessen', function () {
		zu(true);
	});

	jQuery(document).on('keyup', function (event) {
		if (event.key === 'Escape' && $menue.hasClass('ist-offen')) {
			zu(true);
		}
	});

});
